var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuildingDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 453,
    height: 452,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 134,
    width: 453,
    height: 452
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-111 -134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.472 166.7 306.23 144.473 306.056 145.432 306.056 173.156 315.486 174.87 315.486 193.042 268.389 193.042 268.389 93.3484 277.806 91.0356 277.806 61.9442 23.556 124.392 23.556 153.483 32.9725 151.17 32.9725 386.083 268.389 386.083 268.389 320.167 315.472 320.167 315.472 386.083 419.069 386.083 419.069 193.705 428.472 195.414ZM61.2225 211.875 108.306 211.875 108.306 273.083 61.2225 273.083ZM127.139 211.875 174.222 211.875 174.222 273.083 127.139 273.083ZM127.139 193.042 127.139 128.041 174.222 116.477 174.222 193.042ZM193.056 211.875 240.139 211.875 240.139 273.083 193.056 273.083ZM315.486 211.875 315.486 273.083 268.389 273.083 268.389 211.875ZM240.139 193.042 193.056 193.042 193.056 111.852 240.139 100.287ZM108.306 132.667 108.306 193.042 61.2225 193.042 61.2225 144.232ZM390.819 273.083 343.736 273.083 343.736 180.008 390.819 188.568Z",
    transform: "matrix(1.00221 0 0 1 111 134)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingDark);
export default __webpack_public_path__ + "static/media/building_dark.2c8b266f0edddb3f94084feb8bbd87c9.svg";
export { ForwardRef as ReactComponent };